import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Typography,
  Paper,
  IconButton,
  Box,
  Modal,
} from "@mui/material";
import { CloseRounded } from "@mui/icons-material";

import { deleteGame, savePrevGame, updateUser } from "../../actions";
import * as api from "../../api";
import { maxQuestionsByRegion } from "../../data/index.js";

const GameResults = ({ open, setOpen, game, score }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState(null);
  const [prevHighscore, setPrevHighscore] = useState(null);

  let { title, questions, mode, region, listCategory } = game;
  const getPrevHighscore = (user) => {
    if (["Flags", "Capitals"].includes(title)) {
      return user.stats[title][mode][region];
    } else if (["Lists", "Maps"].includes(title)) {
      return user.stats[title][region];
    } else {
      return user.stats[title][listCategory][region];
    }
  };

  useEffect(() => {
    const getCurrentUser = async () => {
      let { data } = await api.getUser(localStorage.getItem("userid"));
      let maxQuestions =
        maxQuestionsByRegion[region][`${title === "Maps" ? "maps" : "other"}`];

      if (data[0] && questions === maxQuestions) {
        setCurrentUser(data[0]);
        setPrevHighscore(getPrevHighscore(data[0]));
      }
    };
    getCurrentUser();
  }, [prevHighscore, score, questions, region, title]);

  const getUpdatedUser = (user) => {
    let updatedUser = { ...user };
    if (["Flags", "Capitals"].includes(title)) {
      updatedUser.stats[title][mode][region] = score;
    } else if (["Lists", "Maps"].includes(title)) {
      updatedUser.stats[title][region] = score;
    } else {
      updatedUser.stats[title][listCategory][region] = score;
    }

    return updatedUser;
  };

  const handlePlayAgain = () => {
    dispatch(deleteGame());
    dispatch(savePrevGame(game));
    if (score > prevHighscore) {
      let updatedUser = getUpdatedUser(currentUser);
      dispatch(updateUser(currentUser.id, updatedUser));
    }
    setOpen(false);
    navigate(`/${title}`);
  };

  const handleEndGame = () => {
    setOpen(false);
    dispatch(savePrevGame(null));
    if (score > prevHighscore) {
      let updatedUser = getUpdatedUser(currentUser);
      dispatch(updateUser(currentUser.id, updatedUser));
    }
    if (title !== "Lists") {
      navigate(`/`);
    }
  };

  const renderHighScoreDisplay = () => {
    if (!currentUser || prevHighscore === null) {
      return null;
    }
    return score > prevHighscore ? (
      <Typography variant="h6" sx={{ color: "#e7b61c" }}>
        New Highscore!
      </Typography>
    ) : (
      <Typography>Highscore: {prevHighscore}</Typography>
    );
  };

  return (
    <Modal
      open={open}
      onClose={handleEndGame}
      sx={{
        width: "90%",
        height: "90%",
        margin: "5% auto",
      }}
    >
      <Paper
        elevation={5}
        sx={{
          borderRadius: "10px",
          width: { sm: "80%", xs: "90%", md: "50%" },
          margin: 0,
          padding: "1rem",
          position: "absolute",
          top: "50%",
          left: "50%",
          msTransform: "translate(-50%, -50%)",
          transform: "translate(-50%, -50%)",
          backgroundColor: "background.default",
        }}
      >
        <IconButton onClick={handleEndGame}>
          <CloseRounded
            sx={{
              cursor: "pointer",
              color: "text",
              fontSize: "25px",
            }}
          />
        </IconButton>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "2rem",
            padding: "1rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{ textAlign: "center" }}
            >{`${region} ${title}`}</Typography>
            <Typography variant="h6">{mode || listCategory}</Typography>
          </Box>

          <Typography variant="h5">{`${score} / ${questions}`}</Typography>
          {renderHighScoreDisplay()}
          <Button
            variant="contained"
            sx={{
              width: { xs: "60%", sm: "40%" },
            }}
            onClick={() => {
              handlePlayAgain(game);
            }}
          >
            Play again
          </Button>
          {title === "Lists" ? (
            <Button
              size="small"
              sx={{
                width: "50%",
                color: "gray",
                fontSize: "10px",
              }}
              onClick={() => {
                setOpen(false);
                if (title !== "Lists") {
                  navigate(`/`);
                }
              }}
            >
              View Answers
            </Button>
          ) : null}
        </Box>
      </Paper>
    </Modal>
  );
};

export default GameResults;

//share button at the bottom middle to send a pic and a link to the game?

/*
highscores implementation...

only some games have highscores...perhaps show an indication in the game setup form whether that game is a highscore enabled game?
show highscore in the game results modal - once the currentuser is fetched
need a function that will determine what the users high score is for the particular game
need a function that will update the user with the new highscore, when applicable
need to indicate to the user if they got a new high score in their current game, if not than display their existing high score
need to dispatch an updateUser action to update the database
user
*/
